<template>
  <div style="overflow:hidden;">
    <div class="box">
      <div class="panel panel-primary" style="position: relative">
        <iframe
          id="external-frame"
          width="100%"
          height="580px"
          :src="iframeUrl"
          frameborder="0"
        ></iframe>
      </div>
      <div class="panel panel-primary" style="position: relative">
        <el-row v-if="showSampleDevice">
          <el-col :span="10">
            <p style="font-size: 18px; text-align:left; padding: 10px;">
              采水样设备 {{ sampleDevice_data.sample_device }}
            </p>
          </el-col>
          <el-col :span="10">
            <el-col
              :span="8"
              v-for="(item, index) in sampleDevice_data.bottle_data"
              :key="index"
            >
              <img
                v-if="item.is_empty"
                :src="require('@/assets/icon/empty0' + item.seq + '.svg')"
                alt=""
              />
              <img
                v-else
                :src="require('@/assets/icon/full0' + item.seq + '.svg')"
                alt=""
              />
            </el-col>
          </el-col>
          <!-- <el-col :span="4">
                    <el-button type="success" style="margin-top: 6px;" @click="getSampleRecords">采样记录</el-button>
                </el-col> -->
        </el-row>
        <div v-if="showSampleDevice">
          <el-table :data="sampleRecords" height="200px" style="width: 100%">
            <el-table-column
              prop="seq"
              label="瓶号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sample_time"
              label="下发时间"
              width="170"
              align="center"
              :formatter="dateFormat"
            ></el-table-column>
            <el-table-column
              prop="complete_time"
              label="执行时间"
              width="170"
              align="center"
              :formatter="dateFormat"
            ></el-table-column>
            <el-table-column
              prop="cod"
              label="COD"
              width="150"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="task_type"
              label="规则类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
            ></el-table-column>
            <!-- <el-table-column prop="sample_device" label="采样设备"  align="center"></el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Col,
  Dialog,
  Row,
  Table,
  TableColumn,
  DatePicker,
  InputNumber as elementInputNumber,
  Loading,
  TimePicker,
  Message
} from "element-ui";
Vue.use(Col);
Vue.use(Row);
Vue.use(Dialog);
Vue.use(Table);
Vue.use(TableColumn);
import { getStationSampleRecords } from "@/api/api";
export default {
  data() {
    return {
      map: null,
      showSampleRecords: this.showSampleDevice,
      sampleRecords: null
    };
  },
  props: {
    iframeUrl: String,
    showSampleDevice: Boolean,
    sampleDevice_data: Object,
    stationName: String
  },
  mounted() {
    this.getSampleRecords();
  },
  methods: {
    async getSampleRecords() {
      console.log(this.stationName, "------------------------------");

      await getStationSampleRecords(this.stationName).then(x => {
        this.sampleRecords = x.data;
        console.log(this.sampleRecords);
      });
      this.showSampleRecords = true;
    },
    dateFormat(row, column, cellval, index) {
      let datetime = cellval
        ? this.$moment(cellval).format("YYYY-MM-DD HH:mm:ss")
        : "";
      return datetime;
    }
  }
};
</script>

<style scoped>
.box {
  height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
}
.box::-webkit-scrollbar {
  display: none;
}
</style>
